export const ScriptManagementNavigation = {
    ScriptManagementPage: '/admin/script-management',
    CreateScriptScreen: '/admin/script-management/create',
    EditScriptScreen: '/admin/script-management/:scriptId/edit'
};
